import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppThemeProvider"] */ "/app/src/theme/AppThemeProvider.tsx");
